import { Component, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PRIVACY_POLICY_CONTENT } from './constants';

@Component({
  selector: 'lib-privacy-policy',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './privacy-policy.component.html',
})
export class PrivacyPolicyComponent {
  constructor(private readonly _translate: TranslateService) {}

  content = input<string>();

  public get privacyPolicyContent(): string {
    if (this.content()) {
      return this.content() + '';
    }
    const lang = this._translate.currentLang || this._translate.defaultLang;
    const content = PRIVACY_POLICY_CONTENT;

    if (lang === 'es') {
      return content.es;
    }

    // Default to English for 'en' or any other language
    return content.en;
  }
}
